import { Injectable } from "@angular/core";
import { IProcessDto } from "core/dto";
import { Observable } from "rxjs";
import { controllerEndpoints } from "../controller.endpoints";
import { ServerSideEventsService } from "../server-side-events.service";

export type LProcessEvent = 'ProcessCreated' |
    'ProcessCancelled' |
    'ProcessFinished' |
    'ProcessDeleted' |
    'ProcessRejected' |
    'ProcessExpired' |
    'ProcessRestarted'

@Injectable({ providedIn: 'root' })
export class ServerSideEventRemoteControllerService {

    private readonly _endpoint = controllerEndpoints.SERVER_SIDE_EVENTS;
    private readonly PROCESS_UPDATES = 'process/updates'

    constructor(
        private readonly _serverSideEventsService: ServerSideEventsService
    ) {

    }



    readonly #processMapper = (messageEvent: MessageEvent) => JSON.parse(messageEvent.data) as IProcessDto
    readonly #processEventDict: Record<LProcessEvent, (messageEvent: MessageEvent) => IProcessDto> = {
        ProcessCancelled: this.#processMapper,
        ProcessCreated: this.#processMapper,
        ProcessDeleted: this.#processMapper,
        ProcessExpired: this.#processMapper,
        ProcessFinished: this.#processMapper,
        ProcessRejected: this.#processMapper,
        ProcessRestarted: this.#processMapper
    }

    subscribeToProcessUpdates(queryParams: Record<string, string>, until?: Observable<any>) {

        return this._serverSideEventsService.subscribeToAnEvent<LProcessEvent, IProcessDto>(
            this._endpoint + '/' + this.PROCESS_UPDATES + this.#toQueryStringParams({ ...queryParams, cacheBuster: Date.now().toString() }), this.#processEventDict, until)
    }

    #toQueryStringParams(queryParams: Record<string, string>) {
        if (!queryParams) {
            return '';
        }


        return '?' + Object.entries(queryParams).map(([key, value]) => key + '=' + encodeURIComponent(value)).join('&')
    }

}